import { Component, Output, EventEmitter, inject } from '@angular/core';
import { AdminService } from '../../admin.service';
import { saveAs } from '@progress/kendo-file-saver';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-download-handlebar-template',
  templateUrl: './download-handlebar-template.component.html',
  styleUrls: ['../toolbox.component.scss'],
  imports: [MatButtonModule],
})
export class DownloadHandlebarTemplateComponent {
  private admnSrvc = inject(AdminService);

  @Output() toggleLoading = new EventEmitter();
  downloadLifeProducts = { table: null, status: null, statusClass: null };

  getHandlebarTemplates() {
    this.toggleLoading.emit();
    this.admnSrvc.downloadHandlebarTemplates().subscribe(res => {
      this.toggleLoading.emit();
      let fileData;
      const filename = `HandlebarTemplates.zip`;
      const reader = new FileReader();
      reader.readAsDataURL(res);

      reader.onloadend = () => {
        fileData = reader.result;
        saveAs(fileData, filename);
      };
    });
  }
}
